// *****************************************
// ************* Image Gallery *************
// *****************************************

import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';

import './image-galleries.scss';

class ImageGallery {

    constructor(el) {
        this.el = el;
        this.imageSizesOkay = true;
        this.lightbox = null;
        // get items
        this.items = [];
        let findItems = this.el.querySelectorAll('a');
        this.loop = findItems.length > 1;
        if(findItems != null) {
            [...findItems].forEach((itemElement, itemIndex) => {
                let dataWidth = itemElement.dataset.pswpWidth,
                    dataHeight = itemElement.dataset.pswpHeight;
                this.items[itemIndex] = {
                    src: itemElement.getAttribute('href'),
                    width: parseFloat(dataWidth) > 0 ? parseFloat(dataWidth) : 0,
                    height: parseFloat(dataHeight) > 0 ? parseFloat(dataHeight) : 0,
                    alt: itemElement.querySelector('figcaption').innerText
                };
                this.imageSizesOkay = this.items[itemIndex].width > 0 && this.items[itemIndex].height > 0;
                let _this = this;
                // behaviour
                itemElement.onclick = (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if(!_this.imageSizesOkay) {
                        _this.getImageDimensions(itemIndex);
                    } else {
                        this.createLightbox(itemIndex);
                    }
                };
            });
        }
    }

    getImageDimensions(priorityIndex) {
        // priority index
        if(this.items[priorityIndex].width == 0 || this.items[priorityIndex].height == 0) {
            let index = priorityIndex;
            this.items[priorityIndex].image = new Image();
            this.items[priorityIndex].image.onload = () => {
                this.imageLoaded(priorityIndex, true);
            }
            this.items[priorityIndex].image.src = this.items[priorityIndex].src;
        } else {
            this.createLightbox(priorityIndex);
        }
        // other images
        for(var x=0; x < this.items.length; x++) {
            if( x !== priorityIndex) {
                if(this.items[x].width == 0 || this.items[x].height == 0) {
                    let index = x;
                    this.items[x].image = new Image();
                    this.items[x].image.onload = () => {
                        this.imageLoaded(index, false);
                    }
                    this.items[x].image.src = this.items[x].src;
                }
            }
        };
    }

    imageLoaded(i, create) {
        let w = this.items[i].image.width,
            h = this.items[i].image.height;
        this.items[i].width = w;
        this.items[i].height = h;
        if(create) {
            this.lightbox= new PhotoSwipe({
                dataSource: this.items,
                loop: this.loop,
                index: i
            });
            this.lightbox.init();
        } else {
            this.lightbox.options.dataSource[i].width = w;
            this.lightbox.options.dataSource[i].height = h;
            this.lightbox.refreshSlideContent(i);
        }
    }

    createLightbox(imageIndex) {
        this.lightbox = new PhotoSwipe({
            dataSource: this.items,
            loop: this.loop,
            index: imageIndex
        });
        this.lightbox.init();
    }

}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ImageGallery(node);
        }
    });
}